import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import Button from '../../../../components/tailwind/Button'
import Modal from '../../../../components/tailwind/Modal'
import { Heading } from '../../../../components/ui/Heading'
import trackEvents from '../../../../constants/track-events'
import { trackEvent } from '../../../../helpers/analytics'

export default function HowToContinueModal({ open, setOpen }) {
  const { t } = useTranslation()
  const navigate = useNavigate()

  useEffect(() => {
    if (open) {
      trackEvent(trackEvents.ONBOARDING_CONTINUE_MODAL_SHOWN)
    }
  }, [open])

  const handleCreateJob = () => {
    trackEvent(trackEvents.ONBOARDING_CREATE_JOB_CLICKED)
    setOpen(false)
    navigate('/career/new')
  }

  const handleInviteCandidate = () => {
    trackEvent(trackEvents.ONBOARDING_INVITE_CANDIDATE_CLICKED)
    setOpen(false)
    navigate('/talents')
  }

  const handleContinueLater = () => {
    trackEvent(trackEvents.ONBOARDING_CONTINUE_LATER_CLICKED)
    setOpen(false)
  }

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      borderRadius='rounded-xl'
      size='xl'
      hideCloseButton
    >
      <Heading level={2} className={'text-center'}>
        {t('how_to_continue.title')}
      </Heading>
      <div className='mt-4'>
        <p className='text-center text-sm text-rockGrey'>
          {t('how_to_continue.description')}
        </p>
      </div>
      <div className='mt-8 space-y-3'>
        <Button.PrimaryLG
          text={t('how_to_continue.create_job')}
          onClick={handleCreateJob}
          className='w-full'
        />
        <Button.SecondaryLG
          text={t('how_to_continue.invite_candidate')}
          onClick={handleInviteCandidate}
          className='w-full'
        />
        <button
          onClick={handleContinueLater}
          className='w-full py-3 text-center text-sm text-rockGrey hover:text-darkBlack'
        >
          {t('how_to_continue.continue_later')}
        </button>
      </div>
    </Modal>
  )
}
